import { render, staticRenderFns } from "./PaperList.vue?vue&type=template&id=4fb3740c&scoped=true"
import script from "./PaperList.vue?vue&type=script&lang=js"
export * from "./PaperList.vue?vue&type=script&lang=js"
import style0 from "./PaperList.vue?vue&type=style&index=0&id=4fb3740c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3740c",
  null
  
)

export default component.exports